import { PdfDocumentStorageProvider } from '@readsavor/utils';
import { ContentType, } from '@readsavor/types';
import { ContentProcessorService } from '../../content/services/content-processor.service.js';
export class PdfManager {
    constructor() {
        this.pdfStorageProvider = PdfDocumentStorageProvider.getInstance();
        this.contentProcessor = ContentProcessorService.getInstance();
    }
    static getInstance() {
        if (!PdfManager.instance) {
            PdfManager.instance = new PdfManager();
        }
        return PdfManager.instance;
    }
    async storeDocument(file, arrayBuffer, options) {
        // 步骤 1: 调用内容处理器来解析PDF并获取格式化好的段落和元数据
        const { metadata } = await this.contentProcessor.processContent(ContentType.PDF, file);
        // 使用类型断言来告诉TypeScript我们期望的metadata结构
        const fullMetadata = metadata;
        const paragraphs = fullMetadata.pdfParagraphs || [];
        const totalPages = fullMetadata.totalPages || 0;
        const pageInfos = fullMetadata.pageInfos || [];
        // 步骤 2: 组装文档元数据
        const docToStore = {
            contentType: 'pdf',
            title: options.title || file.name,
            filename: file.name,
            timestamp: Date.now(),
            language: options.language,
            targetLanguage: options.targetLanguage,
            size: arrayBuffer.byteLength,
            pdfContent: arrayBuffer,
            totalPages: totalPages,
            totalParagraphs: paragraphs.length,
            lastAccessTime: Date.now(),
        };
        // 步骤 3: 调用 Provider 的新方法来完成原子存储
        const newDocId = await this.pdfStorageProvider.addDocumentWithAllData(docToStore, paragraphs, pageInfos);
        return newDocId;
    }
    async loadDocument(identity) {
        const document = await this.pdfStorageProvider.getDocument(identity);
        if (!document) {
            console.error(`[PdfManager.loadDocument] Document not found in storage for identity:`, JSON.stringify(identity));
            throw new Error(`PDF document with identity ${JSON.stringify(identity)} not found.`);
        }
        if (!document.pdfContent) {
            console.error(`[PdfManager.loadDocument] PDF content missing for document (after storage fetch):`, JSON.stringify(identity));
            throw new Error(`PDF content is missing for document ${JSON.stringify(identity)} after storage fetch.`);
        }
        const loadResultToReturn = {
            identity: identity,
            title: document.title || document.filename || 'Untitled PDF',
            filename: document.filename,
            language: document.language || 'und',
            targetLanguage: document.targetLanguage,
            totalPages: document.totalPages,
            pdfContent: document.pdfContent,
        };
        return loadResultToReturn;
    }
    async deleteDocument(identity) {
        await this.pdfStorageProvider.deleteDocument(identity);
    }
    async updateReadingPosition(identity, position) {
        await this.pdfStorageProvider.updateDocument(identity, {
            readingAnchor: position,
            lastAccessTime: Date.now(),
        });
    }
    async getPdfContent(identity) {
        const document = await this.pdfStorageProvider.getDocument(identity);
        if (!document) {
            console.warn(`[PdfManager.getPdfContent] Document not found for identity:`, JSON.stringify(identity));
            return undefined;
        }
        if (!document.pdfContent) {
            console.warn(`[PdfManager.getPdfContent] PDF content is missing in fetched document for identity:`, JSON.stringify(identity));
        }
        return document?.pdfContent;
    }
}
PdfManager.instance = null;
//# sourceMappingURL=PdfManager.js.map